import { StageDiveConfig } from '../util/app_initialization/appconfig'
import { EmailAddress } from '@amzn/aapn-type-guards'
import { CurrencyCode, PartnerAccreditation } from '../generated/graphql'
import { SupportedLocale } from '@amzn/aapn-stage-dive-shared-types'

export const SHARED_ADDRESS1_INPUT_LABEL = 'SHARED:ADDRESS1_INPUT:LABEL'
export const SHARED_ADDRESS2_INPUT_LABEL = 'SHARED:ADDRESS2_INPUT:LABEL'
export const SHARED_CITY_INPUT_LABEL = 'SHARED:CITY_INPUT:LABEL'
export const SHARED_COUNTY_INPUT_LABEL = 'SHARED:COUNTY_INPUT:LABEL'
export const SHARED_STATE_INPUT_LABEL = 'SHARED:STATE_INPUT:LABEL'
export const SHARED_ZIP_INPUT_LABEL = 'SHARED:ZIP_INPUT:LABEL'

export const POLL_INTERVAL = 30000
export const CERTIFIED_USERS_BADGE = 'SHARED:CERTIFIED_USERS_BADGE'
export const EXISTING_USERS_BADGE = 'SHARED:EXISTING_USERS_BADGE'
export const CERTIFICATIONS_BADGE = 'SHARED:CERTIFICATIONS_BADGE'
export const SEARCH_PLACEHOLDER = 'SHARED:SEARCH_PLACEHOLDER'
export const FILTERS = 'SHARED:FILTERS'
export const APPLY = 'SHARED:APPLY'
export const REMOVE = 'SHARED:REMOVE'
export const CANCEL = 'SHARED:CANCEL'
export const FIELD_CHARACTER_LIMIT_ERROR = 'SHARED:FIELD_CHARACTER_LIMIT_ERROR'
export const FIELD_EMAIL_ERROR = 'SHARED:FIELD_EMAIL_ERROR'
export const FIELD_NUMBER_ERROR = 'SHARED:FIELD_NUMBER_ERROR'
export const FIELD_POSITIVE_NON_ZERO_NUM_ERROR = 'SHARED:FIELD_NEGATIVE_NUMBER_ERROR'
export const REQUIRED_FIELD_ONE_CHOICE_ERROR = 'SHARED:REQUIRED_FIELD_ONE_CHOICE_ERROR'
export const ERROR_MESSAGE_LINKEDIN_URL = 'DIRECTORY_PROFILE:SOCIAL_PROFILE:URL_VALIDATION_MESSAGE'
export const FIELD_OPTION_ERROR = 'SHARED:FIELD_OPTION_ERROR'
export const FIELD_WEBSITE_ERROR = 'SHARED:FIELD_WEBSITE_ERROR'
export const FIELD_COMPANY_LOGO_ERROR = 'SHARED:FIELD_COMPANY_LOGO_ERROR'
export const PAST_DATE_VALIDATION = 'SHARED:FIELD_END_DATE_ERROR'
export const GLOBAL_ERROR_TITLE = 'GLOBAL_ERROR:TITLE'
export const GLOBAL_ERROR_MESSAGE = 'GLOBAL_ERROR:MESSAGE'
export const GLOBAL_ERROR_DISPLAY_TEXT = 'GLOBAL_ERROR:DISPLAY_TEXT'
export const GLOBAL_ERROR_BUTTON_TEXT = 'GLOBAL_ERROR:BUTTON_TEXT'
export const REQUIRED_FIELD_MULTIPLE_CHOICE_ERROR = 'SHARED:REQUIRED_FIELD_MULTIPLE_CHOICE_ERROR'
export const BOOLEAN_SELECT_ONE_ERROR = 'SHARED:PLEASE_SELECT_ONE'
export const UNRECOGNIZED_EMAIL_ERROR_MESSAGE = 'SHARED:UNRECOGNIZED_EMAIL_ERROR_MESSAGE'
export const UNRECOGNIZED_EMAIL_ERROR_ROUTE_DISPLAY_TEXT = 'SHARED:UNRECOGNIZED_EMAIL_ERROR_ROUTE_DISPLAY_TEXT'
export const UNRECOGNIZED_EMAIL_ERROR_SWITCH_ACCOUNTS = 'SHARED:UNRECOGNIZED_EMAIL_ERROR_SWITCH_ACCOUNTS'
export const UNRECOGNIZED_EMAIL_ERROR_TITLE = 'SHARED:UNRECOGNIZED_EMAIL_ERROR_TITLE'
export const PARTNER_ACCESS_ERROR_MESSAGE = 'SHARED:PARTNER_ACCESS_ERROR_MESSAGE'
export const PARTNER_ACCESS_ERROR_BUTTON_TEXT = 'SHARED:PARTNER_ACCESS_ERROR_BUTTON_TEXT'
export const PARTNER_ACCESS_ERROR_TITLE = 'SHARED:PARTNER_ACCESS_ERROR_TITLE'
export const UNAUTHORIZED_ACCESS_TITLE = 'AUTHORIZED_ROUTE:CARD:TITLE'
export const UNAUTHORIZED_ACCESS_MESSAGE = 'AUTHORIZED_ROUTE:CARD:MESSAGE'
export const UNAUTHORIZED_ACCESS_DISPLAY_TEXT = 'AUTHORIZED_ROUTE:DISPLAY_TEXT'
export const RETURN_TO_HOMEPAGE = 'AUTHORIZED_ROUTE:LINK:LABEL'

export const RESET = 'SHARED:RESET'
export const AUTH_END_POINT = 'https://development.amazon.com/ap/signin'
export const REDIRECT_URL = 'https://advertising.integ.amazon.com/'

export const MOCKED_USER_ID = 'mockUserId'
export const MOCKED_PARTNER_ID = 'mockPartnerId'
export const MOCKED_USER_NAME = 'Mary Major'
export const USER_EMAIL = 'user@email.com' as EmailAddress
export const ACCREDITATION_PARTNER = PartnerAccreditation.Partner

export const APP_CONFIG_PROD: StageDiveConfig = {
  apiEndpoint: 'https://lnsja60152.execute-api.us-west-2.amazonaws.com/alpha/graphql',
  apiMarketplaceId: 'ATVPDKIKX0DER',
  apiClientId: 'amzn.advertising.789c33b03437b03437343432343400000fe60267',
  authRedirectUrl: 'http://localhost:8080/auth',
  apiRegistrationEndpoint: '/foo',
  hostname: 'https://devlaptop.integ.amazon.com:8080',
  partnerDirectoryUrl: 'https://advertising.amazon.com/partners/directory',
  useApiFormMockAxios: true,
  useFedApiGateway: false,
  authPortalEndpoint: 'https://development.amazon.com/ap/signin',
  metricsEndpoint: {
    stage: 'dev',
    site: 'AAPN',
    app: 'AAPNStageDive',
  },
  metricsEndpointForTestDataSet: {
    stage: 'dev.test',
  },
  useApiRegistrationProductionOid: true,
  stage: 'dev',
}

export const APP_CONFIG_DEV: StageDiveConfig = {
  apiEndpoint: 'https://lnsja60152.execute-api.us-west-2.amazonaws.com/alpha/graphql',
  apiMarketplaceId: 'ATVPDKIKX0DER',
  apiClientId: 'amzn.advertising.789c33b03437b03437343432343400000fe60267',
  authRedirectUrl: 'http://localhost:8080/auth',
  apiRegistrationEndpoint: '/foo',
  hostname: 'https://devlaptop.integ.amazon.com:8080',
  partnerDirectoryUrl: 'https://advertising.integ.amazon.com/partners/directory',
  useApiFormMockAxios: true,
  useFedApiGateway: false,
  authPortalEndpoint: 'https://development.amazon.com/ap/signin',
  metricsEndpoint: {
    stage: 'dev',
    site: 'AAPN',
    app: 'AAPNStageDive',
  },
  metricsEndpointForTestDataSet: {
    stage: 'dev.test',
  },
  useApiRegistrationProductionOid: false,
  stage: 'dev',
}

export const COLOR_MIDNIGHT = 'rgb(35, 47, 62)'
export const COLOR_RHINO = 'rgb(58, 69, 83)'
export const COLOR_DARK_CERULEAN = 'rgb(0, 90, 149)'
export const COLOR_DARKER_CERULEAN = 'rgb(0, 73, 122)'
export const COLOR_PATTENS_BLUE = 'rgb(230, 232, 233)'

const MARKETING_GUIDELINES_URL: Map<SupportedLocale, string> = new Map([
  ['en-US', 'https://advertising.amazon.com/resources/ad-policy/marketing-guidelines-agencies-tool-providers?ref=prtnrntk-drl-tp-0621'],
  ['zh-CN', 'https://advertising.amazon.com/zh-cn/resources/ad-policy/marketing-guidelines-agencies-tool-providers?ref=prtnrntk-drl-tp-0322'],
  ['ja-JP', 'https://advertising.amazon.com/ja-jp/resources/ad-policy/marketing-guidelines-agencies-tool-providers?ref=prtnrntk-drl-tp-0322'],
])

// Decided to use base link (which en-US uses) for all languages. We are doing this because even if we are using specific urls for each language, A20M is redirecting to the marketing content translated in the A20M user LOP.
export const getMarketingGuidelinesURL = (language: SupportedLocale): string | undefined =>
  MARKETING_GUIDELINES_URL.get(language) ?? MARKETING_GUIDELINES_URL.get('en-US')

export const DEVELOPER_CONSOLE_URL = 'https://developer.amazon.com/'
export const DATA_SCOPE_DEFINITION_URL = 'https://advertising.amazon.com/API/docs/en-us/setting-up/step-4-authorization-grant#S'
export const LEARNING_CONSOLE_URL = 'https://learningconsole.amazonadvertising.com/student/catalog'
export const LEARNING_CONSOLE_LABEL = 'SHARED:LEARNING_CONSOLE_LABEL'
export const MARKETING_GUIDELINES_LABEL = 'SHARED:MARKETING_GUIDELINES_LABEL'
export const PARTNER_DIRECTORY_LABEL = 'SHARED:PARTNER_DIRECTORY_LABEL'

export const CURRENCY_TO_LOCALE: Map<CurrencyCode, string> = new Map([
  [CurrencyCode.Aed, 'ar-AE'],
  [CurrencyCode.Aud, 'en-AU'],
  [CurrencyCode.Brl, 'pt-BR'],
  [CurrencyCode.Cad, 'en-CA'],
  [CurrencyCode.Cny, 'zh-CN'],
  [CurrencyCode.Eur, 'es-ES'],
  [CurrencyCode.Gbp, 'en-GB'],
  [CurrencyCode.Inr, 'en-IN'],
  [CurrencyCode.Jpy, 'ja-JP'],
  [CurrencyCode.Mxn, 'es-MX'],
  [CurrencyCode.Pln, 'pl-PL'],
  [CurrencyCode.Sar, 'ar-SA'],
  [CurrencyCode.Sek, 'sv-SE'],
  [CurrencyCode.Sgd, 'en-SG'],
  [CurrencyCode.Try, 'tr-TR'],
  [CurrencyCode.Usd, 'en-US'],
  [CurrencyCode.Zar, 'en-ZA'],
])

export const PRIVACY_NOTICE_LINK = 'https://www.amazon.com/gp/help/customer/display.html?ie=UTF8&nodeId=468496'

export const EMPTY_VALUE = '--'
